import { useEffect, useState } from "react";

import { DayPicker } from "react-day-picker";
import {
    af,
    ar,
    az,
    be,
    bg,
    bn,
    bs,
    ca,
    cs,
    cy,
    da,
    de,
    el,
    eo,
    es,
    et,
    eu,
    fi,
    fr,
    gl,
    gu,
    he,
    hi,
    hr,
    hu,
    hy,
    id,
    is,
    it,
    ja,
    ka,
    kn,
    ko,
    lb,
    lt,
    lv,
    mk,
    ms,
    mt,
    nb,
    nl,
    nn,
    pl,
    ro,
    ru,
    sk,
    sl,
    sq,
    sr,
    sv,
    ta,
    te,
    th,
    tr,
    uk,
    vi,
    pt,
    zhCN,
    zhHK,
    zhTW,
    ptBR,
} from "date-fns/locale";
import "react-day-picker/dist/style.css";
import { addDays, fromUnixTime, isBefore, isEqual } from "date-fns";

import { Drawer, Button, Text, Icons, useToast, useDrawer } from "../../design";
import { translate } from "../../utils/translations";
import { RDP_CSS } from "../../utils/constants";
import { useAxios, handleError } from "../../utils/helpers";
import { useLoop } from "../loop-provider";

function getDateFnsLocale(locale: string) {
    const map = {
        es: es,
        fr: fr,
        de: de,
        cs: cs,
        it: it,
        pl: pl,
        ru: ru,
        tr: tr,
        uk: uk,
        ja: ja,
        ko: ko,
        ar: ar,
        af: af,
        az: az,
        be: be,
        bg: bg,
        bn: bn,
        bs: bs,
        ca: ca,
        cy: cy,
        da: da,
        el: el,
        eo: eo,
        et: et,
        eu: eu,
        fi: fi,
        gl: gl,
        gu: gu,
        he: he,
        hi: hi,
        hr: hr,
        hu: hu,
        hy: hy,
        id: id,
        is: is,
        ka: ka,
        kn: kn,
        lb: lb,
        lt: lt,
        lv: lv,
        mk: mk,
        ms: ms,
        mt: mt,
        nb: nb,
        nl: nl,
        nn: nn,
        sk: sk,
        sl: sl,
        sq: sq,
        sr: sr,
        sv: sv,
        ta: ta,
        te: te,
        th: th,
        vi: vi,
        ro: ro,
        pt: pt,
        // "pt-BR": ptBR,
        // "zh-CN": zhCN,
        // "zh-HK": zhHK,
        // "zh-TW": zhTW,
    };
    return map[locale] || null;
}

function MergeSubscriptionDateSelectDrawer(props: any) {
    const DAYS = 180;
    const [axios] = useAxios();
    const toasts = useToast();
    const drawers = useDrawer();
    const { locale } = useLoop();
    const [isLoading, setisLoading] = useState(false);
    const [disabledDates, setdisabledDates] = useState([]);

    const findDisabledDates = () => {
        const contract = props.selectedContracts[0];
        let _disabledDates = [];
        let startDate = addDays(new Date(), 1);
        let endDate = addDays(new Date(), props?.limit ?? 180);

        if (contract.billing_policy) {
            if (contract.billing_policy.anchor_type) {
                if (contract.billing_policy.anchor_type == "WEEKDAY") {
                    while (isBefore(startDate, endDate) || isEqual(startDate, endDate)) {
                        if (startDate.getDay() !== contract.billing_policy.anchor_day) {
                            _disabledDates.push(startDate);
                        }
                        startDate = addDays(startDate, 1);
                    }
                } else if (contract.billing_policy.anchor_type == "MONTHDAY") {
                    while (isBefore(startDate, endDate) || isEqual(startDate, endDate)) {
                        if (startDate.getDate() != contract.billing_policy.anchor_day) {
                            _disabledDates.push(startDate);
                        }
                        startDate = addDays(startDate, 1);
                    }
                } else if (contract.billing_policy.anchor_type == "YEARDAY") {
                    while (isBefore(startDate, endDate) || isEqual(startDate, endDate)) {
                        if (
                            startDate.getMonth() != contract.billing_policy.anchor_month - 1 &&
                            startDate.getDate() != contract.billing_policy.anchor_day
                        ) {
                            _disabledDates.push(startDate);
                        }
                        startDate = addDays(startDate, 1);
                    }
                }
            }
        }
        return _disabledDates;
    };

    const getDeliveryDate = (contract) => {
        if (contract.chargeOffset) {
            return addDays(fromUnixTime(contract.next_billing_date), contract.chargeOffset);
        } else {
            return contract.next_billing_date * 1000;
        }
    };

    const handleMonthChange = (newMonth) => {
        setSelectedMonth(newMonth);
    };

    const [selectedDate, setselectedDate] = useState(
        new Date(Math.min(...props.selectedContracts.map((contract: any) => getDeliveryDate(contract)))),
    );
    const [selectedMonth, setSelectedMonth] = useState(selectedDate);

    const handleConfirm = async () => {
        setisLoading(true);
        try {
            if (!selectedDate) {
                setisLoading(false);
                return;
            }

            let _newBillingDate: any = selectedDate.getTime() / 1000;

            const _timeZoneIANA = Intl.DateTimeFormat().resolvedOptions().timeZone;
            let body: any = {
                contracts: props.selectedContracts.map((contract: any) => contract.id),
                new_billing_date: parseInt(_newBillingDate).toString(),
                userTimezone: _timeZoneIANA,
            };
            const { data } = await axios.post(
                `${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/merge_contracts`,
                body,
            );
            toasts.open({ message: data.message, type: data.success ? "success" : "failure", time: 10000 });
            if (data.success) {
                drawers.closeAll();
                props.reloadContracts();
            }
        } catch (e) {
            handleError(e, "./components/drawers/merge-subscription-date-select", "handleConfirm", {});
        }
        setisLoading(false);
    };

    useEffect(() => {
        setdisabledDates(findDisabledDates());
    }, [props.selectedContracts]);

    return (
        <Drawer
            id="'merge-subscriptions-order-date"
            title={translate("merge_subscriptions_order_date_drawer_title")}
            active={props.active}
            toggleActive={props.toggleActive}
        >
            <style>{RDP_CSS}</style>
            <Drawer.Body>
                {isLoading ? (
                    <Icons.Spinner />
                ) : (
                    <>
                        <div className="my-2">
                            <Text.P1>{translate("merge_subscription_choose_order_date_body")}</Text.P1>
                        </div>
                        <div className="w-100 d-flex justify-content-center">
                            <DayPicker
                                mode="single"
                                month={selectedMonth}
                                selected={selectedDate}
                                onSelect={setselectedDate}
                                onMonthChange={handleMonthChange}
                                disabled={[
                                    { before: addDays(new Date(), 1) },
                                    { after: addDays(new Date(), DAYS) },
                                    ...disabledDates,
                                ]}
                                locale={getDateFnsLocale(locale.split("-")[0])}
                            />
                        </div>
                    </>
                )}
            </Drawer.Body>
            <Drawer.Footer>
                <div className="d-flex flex-column">
                    <Button disabled={isLoading} size="lg" className="m-2" onClick={handleConfirm}>
                        {translate("reschedule_order_drawer_confirm_button")}
                    </Button>
                    <Button
                        disabled={isLoading}
                        size="lg"
                        variant="underline"
                        className="m-2"
                        onClick={props.toggleActive}
                    >
                        {translate("go_back_button")}
                    </Button>
                </div>
            </Drawer.Footer>
        </Drawer>
    );
}

export default MergeSubscriptionDateSelectDrawer;
